<script lang="ts">
	import {
		faDiscord,
		faGooglePlay,
		faInstagram,
		faItchIo,
		faSteam,
		faTiktok,
		faYoutube,
		type IconDefinition
	} from '@fortawesome/free-brands-svg-icons';
	import { t } from '$lib/i18n/translation';
	// noinspection ES6UnusedImports
	import Fa from 'svelte-fa';

	interface FooterData {
		lookup: string;
		links: FooterLink[];
	}

	interface FooterLink {
		href: string;
		lookup: string;
		icon?: IconDefinition;
		blank?: boolean;
	}

	const footerData: Array<FooterData> = [
		{
			lookup: 'footer.game_head',
			links: [
				{ href: '/sign-up', lookup: 'navigation.sign_up' },
				{ href: '/login', lookup: 'navigation.login' },
				{ href: '/download', lookup: 'pages.download' },
				{ href: '/reset-password', lookup: 'pages.password_reset' },
				{ href: '/leaderboard', lookup: 'leaderboard.title' },
				{ href: '/shop', lookup: 'navigation.shop' }
			]
		},
		{
			lookup: 'footer.general_head',
			links: [
				{ href: '/news', lookup: 'navigation.news' },
				{ href: '/switch-language', lookup: 'switch_language.role' },
				{ href: '/pages/community-guidelines', lookup: 'pages.community_guidelines' },
				{ href: '/pages/legal-notice', lookup: 'pages.legal' }
			]
		},
		{
			lookup: 'footer.social_head',
			links: [
				{
					blank: true,
					href: 'https://store.steampowered.com/app/2521020/Tales_of_Landor/',
					lookup: 'footer.social.steam',
					icon: faSteam
				},
				{
					blank: true,
					href: 'https://play.google.com/store/apps/details?id=com.lumbago.tol',
					lookup: 'footer.social.google_play',
					icon: faGooglePlay
				},
				{
					blank: true,
					href: 'https://lumbago-interactive.itch.io/tales-of-landor',
					lookup: 'footer.social.itch-io',
					icon: faItchIo
				},
				{
					blank: true,
					href: 'https://tales-of-landor.com/discord',
					lookup: 'footer.social.discord',
					icon: faDiscord
				},
				{
					blank: true,
					href: 'https://www.youtube.com/@TalesOfLandor',
					lookup: 'footer.social.youtube',
					icon: faYoutube
				},
				{
					blank: true,
					href: 'https://www.instagram.com/talesoflandor/',
					lookup: 'footer.social.instagram',
					icon: faInstagram
				},
				{
					blank: true,
					href: 'https://www.tiktok.com/@talesoflandor',
					lookup: 'footer.social.tiktok',
					icon: faTiktok
				}
			]
		}
	];
</script>

<div class="bg-base-200 py-10 border-t border-base-300">
	<footer class="footer container my-10 text-base-content">
		{#each footerData as footerSection}
			<nav>
				<header class="footer-title">{$t(footerSection.lookup)}</header>
				{#each footerSection.links as link}
					<a class="link link-hover" href={link.href} target={link.blank ? '_blank' : undefined}>
						{#if link.icon}
							<Fa fw={true} icon={link.icon} class="inline mr-1" />
						{/if}
						{$t(link.lookup)}
					</a>
				{/each}
			</nav>
		{/each}
	</footer>
	<footer class="footer footer-center">
		<!-- eslint-disable-next-line svelte/no-at-html-tags -->
		{@html $t('footer.copyright')}
	</footer>
</div>
